import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { setupInterceptors } from "./axiosInterceptors";
const baseURL = process.env.REACT_APP_BASE_URL + "/api";

const api = axios.create({
  baseURL, 
  withCredentials: true
});

export default api;


setupInterceptors(api,baseURL)
/**
 * ✅ General GET request hook using React Query
 */
export const useFetchData = (queryKey, endpoint, params = {}) => {
  return useQuery({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey, params],
    queryFn: async () => {
      const { data } = await api.get(endpoint, { params });
      return data;
    },
    staleTime: 10 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (error.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
};



/**
 * ✅ General Mutation Hook (POST, PUT, DELETE)
 */
export const useApiMutation = (method, endpoint = "", onSuccessCallback = null, onErrorCallback = null) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ params, body } = {}) => {
      let url = endpoint;

      // ✅ Append params dynamically if provided
      if (params) {
        url = `${endpoint}/${params}`;
      }

  let headers = {};
if (!(body instanceof FormData)) {
  headers["Content-Type"] = "application/json";
}

      const { data } = await api({
        method,
        url,
        data: body,
        headers,
      });

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["properties"]); // ✅ Clears cache and refetches
      
      if (onSuccessCallback) onSuccessCallback(data);
    },
    onError: (error) => {
      console.error("❌ API Request Failed:", error);

      if (onErrorCallback) onErrorCallback(error);
    },
  });
};

